module.exports = __webpack_public_path__ + "img/1.54ad57f5.png";